import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { SharedModule } from 'src/app/shared/shared.module';
import { AgentTestPanelComponent } from './agent-test-panel.component';

/**
 * O "Testar agente" vive em dois lugares (CU-17tm466mg5z): a tela completa do agente (módulo
 * lazy do Playground) e o formulário curto do passo de WhatsApp (PagesModule). Módulo próprio
 * para os dois importarem sem o PagesModule carregar as rotas do Playground.
 */
@NgModule({
  declarations: [AgentTestPanelComponent],
  imports: [CommonModule, FormsModule, NgbTooltipModule, SharedModule],
  exports: [AgentTestPanelComponent],
})
export class AgentTestPanelModule {}
